import { render, staticRenderFns } from "./BiTableCard.vue?vue&type=template&id=b0c55292&"
import script from "./BiTableCard.vue?vue&type=script&lang=js&"
export * from "./BiTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports